import * as _ from 'lodash';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[numbersOnly]',
    standalone: false
})
export class NumbersOnlyDirective {
    // Allow integers
    private regex = new RegExp(/^[0-9]*$/g);

    // Allow key codes for special events
    private specialKeys = ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];

    constructor(private el: ElementRef) {}

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        const current: string = !_.isUndefined(this.el.nativeElement.value)
            ? this.el.nativeElement.value
            : this.el.nativeElement.querySelector('input').value;
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        const next: string = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}
